// src/viewmodels/useThemeViewModel.js
import { useEffect } from 'react';

export function useThemeViewModel() {
  // Theme is always light
  const isDark = false;

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    localStorage.setItem('portfolio-theme', 'light');
  }, []);

  const toggleTheme = () => {};

  return { isDark, toggleTheme };
}
